import { useRef } from "react";
import { PropTypes } from "base/react-libs";
import { useOpenClose } from "@evertrue/et-components";
import { useGlobalOutreachProvider } from "apps/outreach/contexts/global-outreach-context";
import classNames from "classnames";
import DrawerHeader from "./components/drawer-header";
import useOutsideClick from "hooks/use-outside-click";

export const Drawer = ({
  id, // Unique UUID Generated by the GlobalDrawerContext
  type, // String indicating type of drawer (eg "dialer" "emailer" etc)
  drawerTitle = "New Message", // String to Display in Header
  onClose = () => {}, // Function provided by GlobalDrawerContext
  drawerClassName = "", // Optional Styling to apply to drawer
  scrollable = false, // Indicator if content is scrollable
  children, // content of drawer
  headerIcon = null,
}) => {
  const wrapperRef = useRef(null);
  const { onCall, CallTimer } = useGlobalOutreachProvider();
  const [isMinimized, minimize, maximize] = useOpenClose(false); // when a drawer is opened, default to Minimized == False

  useOutsideClick(wrapperRef, () => {
    // BUGGY WHEN WORKING WITH ListBoxSelect because ListBoxSelect items are not nested inside the drawer component, they are at top of page. So clicking them causes minimization.
    // if (!isMinimized) toggleMinimize();
  });

  return (
    <>
      <div ref={wrapperRef} className={`drawer  ${isMinimized ? "minimized" : ""} ${drawerClassName}`}>
        <DrawerHeader
          type={type}
          onClose={onClose}
          drawerTitle={drawerTitle}
          isMinimized={isMinimized}
          onMinimize={isMinimized ? maximize : minimize}
          headerIcon={headerIcon}
          onCall={onCall}
          CallTimer={CallTimer}
        />
        <div
          data-testid="drawer-content"
          className={classNames(
            isMinimized ? "drawer--content-hidden" : "drawer--content",
            { scrollable: scrollable },
            drawerClassName
          )}
        >
          {children}
        </div>
      </div>
    </>
  );
};

Drawer.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  drawerTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  drawerClassName: PropTypes.string,
  onClose: PropTypes.func,
  scrollable: PropTypes.bool,
  children: PropTypes.node,
  headerIcon: PropTypes.node,
};

export default Drawer;
